import React from 'react'
import { motion } from 'framer-motion'
import GlassPanel from '../components/GlassPanel'
import { useTheme, themeStyles } from '../context/ThemeContext'
import ParticleBackground from '../components/ParticleBackground'

const GameLoadingAnimation: React.FC = () => {
  const { theme } = useTheme();
  const currentTheme = themeStyles[theme];

  // Spinning circle config
  const spinTransition = {
    loop: Infinity,
    ease: 'linear' as const,
    duration: 10,
  }

  // Pulsing dot variants
  const pulseVariants = {
    initial: { scale: 0.8, opacity: 0.3 },
    animate: { scale: 1, opacity: 1 },
  }

  return (
    <div className={`relative h-screen w-screen overflow-hidden flex flex-col items-center justify-center p-4 md:p-8 bg-gradient-to-br ${currentTheme.background}`}>
      {/* Background elements */}
      <ParticleBackground />

      {/* Main Container */}
      <motion.div
        className="relative z-10 max-w-md w-full mx-auto text-center"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* Title */}
        <motion.h1
          className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#4B7BFF] to-[#8E44AD] mb-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          إنشاء اللعبة
        </motion.h1>

        {/* Glass Panel w/ spinner & dots */}
        <GlassPanel className="p-8 flex flex-col items-center">
          {/* Spinning gradient circle */}
          <motion.div
            className="w-20 h-20 rounded-full border-4 border-transparent border-t-[#4B7BFF] border-r-[#8E44AD]"
            animate={{ rotate: 360 }}
            transition={spinTransition}
          />
          {/* Loading text */}
          <div className="mt-8 mb-4">
            <p className={`${currentTheme.text} text-lg`}>يرجى الانتظار...</p>
          </div>
          {/* Pulsing dots */}
          <div className="flex gap-3 mt-2">
            {[0, 1, 2].map((i) => (
              <motion.div
                key={i}
                className="w-3 h-3 rounded-full bg-[#4B7BFF]"
                initial="initial"
                animate="animate"
                variants={pulseVariants}
                transition={{
                  duration: 0.8,
                  repeat: Infinity,
                  repeatType: 'reverse',
                  delay: i * 0.2,
                }}
              />
            ))}
          </div>
        </GlassPanel>

        {/* Subtext */}
        <motion.p
          className={`text-center ${currentTheme.text} mt-6`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          جاري تجهيز كل شيء لبدء اللعبة
        </motion.p>
      </motion.div>
    </div>
  )
}

export default GameLoadingAnimation
